"use strict";

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.assign");

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.create");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  .color-label {\n    display: block;\n    width: 16px;\n    height: 10px;\n    border-radius: ", ";\n    margin: 0 5px 0 0;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorSelect = exports.COLORS = void 0;

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var index_1 = require("./index");

var styledTypes_1 = require("./styledTypes");

exports.COLORS = [{
  key: 'blue',
  name: 'Blue'
}, {
  key: 'green',
  name: 'Green'
}, {
  key: 'orange',
  name: 'Orange'
}, {
  key: 'red',
  name: 'Red'
}, {
  key: 'gray-7',
  name: 'Gray'
}];
var ColorOption = styledTypes_1.styled.div(_templateObject(), function (props) {
  return props.theme['@border-radius-base'];
});

function ColorSelect(props) {
  var theme = (0, react_1.useContext)(index_1.StyledThemeContext);
  return react_1["default"].createElement(antd_1.Select, Object.assign({}, props), exports.COLORS.map(function (color) {
    return react_1["default"].createElement(antd_1.Select.Option, {
      key: color.key,
      value: color.key
    }, react_1["default"].createElement(ColorOption, null, react_1["default"].createElement("span", {
      className: 'color-label',
      style: {
        background: theme["@".concat(color.key)]
      }
    }), react_1["default"].createElement("span", {
      className: 'color-name'
    }, color.name)));
  }));
}

exports.ColorSelect = ColorSelect;